import React from 'react';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '../ui/accordion';
import { useInView } from '../../hooks/useInView';
import { faqItems } from '../../data/mock';

export const FAQSection = () => {
  const [titleRef, titleInView] = useInView();
  const [accordionRef, accordionInView] = useInView();

  return (
    <section id="faq" className="py-24 lg:py-32 bg-white">
      <div className="max-w-3xl mx-auto px-6 lg:px-8">
        <div
          ref={titleRef}
          className={`text-center mb-14 transition-[opacity,transform] duration-700 ease-out ${
            titleInView
              ? 'opacity-100 translate-y-0'
              : 'opacity-0 translate-y-6'
          }`}
        >
          <span className="text-xs font-semibold tracking-widest uppercase text-amber-600 mb-3 block">
            FAQ
          </span>
          <h2 className="text-3xl sm:text-4xl font-bold text-stone-900 mb-4">
            Frequently Asked Questions
          </h2>
          <p className="text-stone-500 text-lg">
            Everything you need to know about our code review process.
          </p>
        </div>

        <div
          ref={accordionRef}
          className={`transition-[opacity,transform] duration-700 ease-out ${
            accordionInView
              ? 'opacity-100 translate-y-0'
              : 'opacity-0 translate-y-6'
          }`}
        >
          <Accordion type="single" collapsible className="space-y-3">
            {faqItems.map((item, i) => (
              <AccordionItem
                key={i}
                value={`item-${i}`}
                className="border border-stone-200 rounded-xl px-6 data-[state=open]:border-amber-300/60 data-[state=open]:shadow-sm transition-[border-color,box-shadow] duration-200"
              >
                <AccordionTrigger className="text-left text-[15px] font-semibold text-stone-800 hover:text-stone-900 py-5 hover:no-underline">
                  {item.question}
                </AccordionTrigger>
                <AccordionContent className="text-sm text-stone-500 leading-relaxed pb-5">
                  {item.answer}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </div>
    </section>
  );
};
